<fuse-drawer class="z-999 w-screen min-w-screen sm:w-100 sm:min-w-100" [fixed]="true" [mode]="'over'"
    [name]="'golfCartDrawer'" [position]="'right'" #golfCartDrawer>

    <div class="bg-card flex w-full flex-col overflow-auto">
        <!-- Header -->
        <div class="flex h-20 min-h-20 flex-row items-center bg-primary px-6 text-white">
            <mat-icon class="text-current icon-size-7" [svgIcon]="'mat_outline:drive_eta'"></mat-icon>
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                Add Golf Cart
            </div>
            <button class="ml-auto" mat-icon-button (click)="golfCartDrawer.close()">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="flex flex-col p-6 gap-4">

            <!-- Player Selection -->
            <div class="flex flex-col gap-4">
                <div class="bg-card flex-col gap-2 rounded-lg shadow overflow-hidden">
                    <!-- Section Header -->
                    <div class="border-b bg-gray-50 p-4 flex flex-col">
                        <span class="font-semibold text-lg">
                            Who will pay for the cart?
                        </span>
                        <span class="text-gray-400 text-sm">
                            Select players to split the cart cost ({{ selectedPayingPlayers.length }}/{{
                            availablePlayers.length }})
                        </span>
                    </div>

                    <!-- Player Selection Grid -->
                    <div class="flex flex-col gap-2 p-4">
                        @for (player of availablePlayers; track player.id) {
                        <div class="relative">
                            <div class="p-4 bg-gray-50 border rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
                                [style.border-color]="isPlayerSelected(player) ? '#059669' : ''"
                                [style.background-color]="isPlayerSelected(player) ? '#059669' + '10' : ''"
                                (click)="togglePlayerSelection(player)">
                                <div class="flex flex-row justify-start items-center gap-2">
                                    <!-- Player Avatar -->
                                    <div
                                        class="w-8 h-8 rounded-full flex items-center justify-center text-white text-base font-medium bg-green-600">
                                        {{ getUserInitials(player) }}
                                    </div>

                                    <!-- Player Name -->
                                    <div class="text-base font-medium text-gray-900">
                                        {{ getUserName(player) }}
                                        @if (player.isCurrentUser) {
                                        <span
                                            class="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                            You
                                        </span>
                                        }
                                    </div>

                                    @if (isPlayerSelected(player)) {
                                    <mat-icon class="ml-auto text-2xl text-green-600"
                                        [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                                    }
                                </div>
                            </div>
                        </div>
                        }

                        @if (availablePlayers.length === 0) {
                        <div class="text-center py-8">
                            <mat-icon class="text-6xl text-gray-400 mb-4"
                                [svgIcon]="'heroicons_outline:users'"></mat-icon>
                            <h3 class="text-lg font-medium text-gray-700 mb-2">No players available</h3>
                            <p class="text-gray-500">
                                Add some players to your booking first to split the cart cost.
                            </p>
                        </div>
                        }
                    </div>
                </div>
            </div>

            <!-- Cost Summary -->
            @if (selectedPayingPlayers.length > 0) {
            <div
                class="p-4 bg-green-50 dark:bg-green-900 dark:bg-opacity-20 rounded-lg border border-green-200 dark:border-green-800">
                <h4 class="font-medium text-green-800 dark:text-green-200 mb-2">Cart Cost Summary</h4>
                <div class="space-y-1 text-sm">
                    <div class="flex justify-between text-green-700 dark:text-green-300">
                        <span>{{ holeTypeDisplayName }} Cart:</span>
                        <span>R{{ selectedPrice | number:'1.2-2' }}</span>
                    </div>
                    <div class="flex justify-between text-green-700 dark:text-green-300">
                        <span>Split between {{ selectedPayingPlayers.length }} player{{ selectedPayingPlayers.length !==
                            1 ? 's' : '' }}:</span>
                        <span>R{{ pricePerPlayer | number:'1.2-2' }} each</span>
                    </div>
                </div>
            </div>
            }

            <!-- Action Buttons -->
            <div class="flex space-x-3">
                <button class="flex-1" mat-stroked-button (click)="golfCartDrawer.close()">
                    Cancel
                </button>
                <button class="flex-1" mat-flat-button color="primary" [disabled]="!canConfirmSelection()"
                    (click)="confirmSelection(); golfCartDrawer.close()">
                    <mat-icon [svgIcon]="'mat_outline:add'" class="mr-2"></mat-icon>
                    Add Cart
                </button>
            </div>
        </div>
    </div>
</fuse-drawer>